import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { feedbackStyles } from '../../Styles/feedbackStyles';
import { inject, observer } from 'mobx-react';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import { withRouter } from 'react-router-dom';

@inject('feedbackStore')
@observer
class FeedbackDialog extends Component {

    closeDialog = () => {
        this.props.feedbackStore.closeFeedbackDialog();
    }

    renderImage = (type) => {
        let imageType = type
        type == 'POPUP_SATISFIED' ? imageType = 'satisfied' : imageType = 'dissatisfied';

        return (
            <ReactSVG
                src={Images[`${imageType}`]} />
        )
    }

    componentDidMount(){
       setTimeout(() =>{
            this.props.feedbackStore.closeFeedbackDialog();
            this.props.history.push({
                pathname: '/home' ,
              })
        }, 5000)
    }

    render() {
        const { classes } = this.props;
        const { openFeedbackDialog, feedbackResponse } = this.props.feedbackStore;
        return (
            <Dialog classes={{ paper: classes.dialog }} open={openFeedbackDialog} onClose={this.closeDialog}>
                <DialogContent style={{marginBottom: '2vh'}}>
                    {feedbackResponse && this.renderImage(feedbackResponse.type)}
                    {feedbackResponse && <Typography className={classes.feedbackInfo}>{feedbackResponse.message}</Typography>}
                </DialogContent>
            </Dialog>
        )
    }
}
FeedbackDialog.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withRouter(withStyles(feedbackStyles)(FeedbackDialog));
